import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { useStyle } from './MainContentTemplate.styles'
import { Card, CardContent, Typography } from '@mui/material'
import LabraLogo from '../../images/labraIcon.svg'
import { labraWebsiteLink } from '../../utils/constants'

export interface MainContentTemplateProps {
  backgroundImgUrl?: string
  children: React.ReactNode
  bgColor?: string
}

export const MainContentTemplate: React.FC<MainContentTemplateProps> = ({
  backgroundImgUrl,
  children,
  bgColor,
}) => {
  const { classes } = useStyle({ backgroundImg: backgroundImgUrl, bgColor })
  return (
    <Grid
      data-testid="main-content"
      container
      component="main"
      className={classes.root}
    >
      <CssBaseline />
      <Grid
        className={classes.image}
        size={{
          xs: false,
          sm: false,
          md: 7,
        }}
      />
      <Grid
        component={Paper}
        elevation={6}
        square
        className={classes.formDiv}
        size={{
          xs: 12,
          sm: 12,
          md: 5,
        }}
      >
        <div className={classes.paper}>
          <section className={classes.divForm}>
            <div className={classes.children}>
              <Card>
                <CardContent
                  className={classes.cardChildrenContent}
                  data-testid="children"
                >
                  {children}
                </CardContent>
              </Card>
            </div>
          </section>
        </div>
        <div className={classes.footer}>
          <PoweredBanner />
        </div>
      </Grid>
    </Grid>
  )
}

export const PoweredBanner: React.FC = () => {
  const { classes } = useStyle({})

  return (
    <div className={classes.banner}>
      <Card className={classes.cardContent}>
        <Typography className={classes.tagText} data-testid="banner-powered">
          Powered by{' '}
          <a href={labraWebsiteLink} target="_blank" rel="noreferrer">
            <img src={LabraLogo} className={classes.logoImg} alt="Labra" />
          </a>
          <a
            className={classes.labraTag}
            href={labraWebsiteLink}
            target="_blank"
            rel="noreferrer"
          >
            labra
          </a>
        </Typography>
      </Card>
    </div>
  )
}
